import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GLOBAL_CONFIG } from '../core/global-config.injection-token';
import { AuthenticationService } from '../core/authentication/auth.service';
import { Client } from '../models/client.model';
import { GlobalConfig } from '../interfaces/global-config.model';

@Injectable()
export class ClientService {
  private basePath = '';

  private clientsUrl = 'api/clients'; // URL to web API

  constructor(
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    @Optional() @Inject(GLOBAL_CONFIG) globalConfig: GlobalConfig
  ) {
    if (globalConfig && globalConfig.basePath) {
      this.basePath = globalConfig.basePath;
    }
  }

  public getClients(): Observable<any[]> {
    return this.getClientNames().pipe(map((name: any) => name));
  }

  public getClientsKeycloak() {
    return this.authenticationService.getClients();
  }

  private getClientNames(): Observable<{}> {
    return this.httpClient
      .get(`${this.basePath}${this.clientsUrl}`)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  private extractData(res: Response) {
    const body = res || {};
    return body;
  }

  private handleError(error: HttpErrorResponse | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errorMessage: string;
    if (error.error instanceof Error) {
      errorMessage = `An error occurred: ${error.error.message}`;
    } else {
      errorMessage = `Backend returned code ${error.status}, body was: ${error.error}`;
    }
    console.error(errorMessage);
    return observableThrowError(errorMessage);
  }

  logout() {
    this.authenticationService.logout();
    this.removeClientName();
    this.removeClientCount();
  }

  public resetClient(client: Client, clientCount: number) {
    this.setClientName(client.name + '');
    this.setClientCount(clientCount);
  }

  getClientName(): string {
    return localStorage.getItem('current_client_name');
  }

  private setClientName(clientName: string): void {
    localStorage.setItem('current_client_name', clientName);
  }

  removeClientName(): void {
    localStorage.removeItem('current_client_name');
  }

  getClientCount(): number {
    return +localStorage.getItem('client_count');
  }

  private setClientCount(clientCount: number): void {
    localStorage.setItem('client_count', `${clientCount}`);
  }

  removeClientCount(): void {
    localStorage.removeItem('client_count');
  }

  public isLoggedIn(): Observable<boolean> {
    return this.authenticationService.isLoggedIn();
  }
}
